import React from 'react';
import { COMPANY } from '../lib/company';

/**
 * Standard "Registered company details" block appended at the foot of every
 * legal page. Kept compact + premium per VinePass brand spec (heritage green,
 * subtle gold eyebrow, generous line height).
 */
const CompanyDetailsBlock = () => (
  <div
    className="mt-12 pt-8 border-t border-stone-200"
    data-testid="company-details-block"
  >
    <p className="text-[10px] uppercase tracking-[0.2em] text-[#C9A27A] mb-3">
      Registered Company Details
    </p>
    <div className="text-sm text-stone-700 space-y-1 leading-relaxed">
      <p className="font-semibold text-[#1F3D2B]">{COMPANY.legalName}</p>
      <p>Registration Number: {COMPANY.registrationNumber}</p>
      <p>Registered in {COMPANY.country}</p>
      <p>
        Contact:{' '}
        <a href={`mailto:${COMPANY.contactEmail}`} className="text-[#1F3D2B] underline">
          {COMPANY.contactEmail}
        </a>
      </p>
      <p>
        Ticket support:{' '}
        <a href={`mailto:${COMPANY.ticketSupportEmail}`} className="text-[#1F3D2B] underline">
          {COMPANY.ticketSupportEmail}
        </a>
      </p>
      <p>
        Website:{' '}
        <a href={`https://${COMPANY.website}`} className="text-[#1F3D2B] underline">
          {COMPANY.website}
        </a>
      </p>
    </div>
  </div>
);

export default CompanyDetailsBlock;
